import Social2 from "../../common/social/Social2";
import blogsData from "../../../data/blogs";
import Link from "next/link";

const DetailsContent = ({ content, terms }) => {
  
  return (
    <>

      <div className="html-content" dangerouslySetInnerHTML={{ __html: content }} />

    </>
  );
};

export default DetailsContent;
